var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_1001",
    "data-name": "Group 1001",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.273,
    height: 35.273,
    viewBox: "0 0 35.273 35.273",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1003",
    "data-name": "Group 1003"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12908",
    "data-name": "Path 12908",
    d: "M35.273,17.637A17.637,17.637,0,1,1,17.637,0,17.637,17.637,0,0,1,35.273,17.637",
    fill: "#ff005e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12909",
    "data-name": "Path 12909",
    d: "M16.014,30.5a1.1,1.1,0,0,1-1.1-1.1v-2.5l-.423-.054a6.365,6.365,0,0,1-5.223-4.288,1.1,1.1,0,0,1,.17-.944,1.126,1.126,0,0,1,.885-.435h.018a1.078,1.078,0,0,1,1.028.747l.008.022a4.274,4.274,0,0,0,3.24,2.781,12.938,12.938,0,0,0,2.78.024,3.609,3.609,0,0,0,3.2-3.3l0-.016v-.018c.027-2.654-2.651-3.3-4.424-3.725l-.685-.169c-2.877-.676-5.846-1.374-5.846-5.27.012-2.794,1.786-4.658,4.868-5.113l.414-.061V4.627a1.1,1.1,0,1,1,2.192,0v2.5l.426.051a5.463,5.463,0,0,1,4.523,3.6,1.1,1.1,0,0,1-1.044,1.426,1.133,1.133,0,0,1-1.059-.755l-.008-.02a3.551,3.551,0,0,0-2.642-2.162c-.032-.007-.167-.036-.212-.049l-.034-.009-.029,0-.145-.021L16.4,9.132c-.168-.013-.243-.014-.317-.014h-.126c-.114,0-.23,0-.344.014h-.149l-.042.007a1.008,1.008,0,0,1-.159.015H15.23l-.4.062c-1.9.369-3,1.463-3.013,3-.026,2.29,2.075,2.79,4.3,3.32l.432.1c3.765.885,6.267,2.206,6.247,5.775-.011,2.717-2.129,4.9-5.273,5.441l-.4.069V29.4a1.1,1.1,0,0,1-1.093,1.1Z",
    transform: "translate(1.623 0.621)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSale);
export default __webpack_public_path__ + "static/media/icon-sale.b794fb9eb07079509c9d08b09b2827c6.svg";
export { ForwardRef as ReactComponent };